import React from 'react';
import { DocumentTextIcon, ShieldCheckIcon, ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import RegisterSocialsComponent from './RegisterSocialsComponent';

const LoginComponent = () => {
  return (
    <section className="min-h-screen flex flex-col md:flex-row bg-white dark:bg-gray-100">
      {/* Left Side: Icons + Message */}
      <div className="md:w-1/2 w-full flex flex-col items-center justify-center bg-[#514a44] dark:bg-gray-100 p-8 text-center">
        <img style={{ borderRadius: "32px" }} src="/logo.png" alt="IPSA Logo" className="w-48 h-auto mb-6  shadow-lg" />
        <h2 className="text-2xl font-bold text-blue-800 dark:text-dark mb-4">Hospital Policy Access</h2>
        <div className="flex space-x-6 mb-4">
          <DocumentTextIcon className="h-10 w-10 text-blue-700 dark:text-dark" />
          <ShieldCheckIcon className="h-10 w-10 text-blue-700 dark:text-dark" />
          <ClipboardDocumentCheckIcon className="h-10 w-10 text-blue-700 dark:text-dark" />
        </div>
        <p className="text-gray-700 dark:text-gray-800 max-w-md">
          Login to access IPSA’s trusted healthcare policies, SOPs, and management systems tailored for hospitals and clinics across Kenya.
        </p>
      </div>

      {/* Right Side: Registration Form */}
      <div className="md:w-1/2 w-full flex items-center justify-center p-8">
        <form className="w-full max-w-md bg-white dark:bg-blue-800 shadow-lg rounded-lg p-6 space-y-4">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">Portal Login</h2>
          <input
            type="text"
            placeholder="Email Address or Phone Number"
            className="w-full px-4 py-2 border rounded-md dark:bg-gray-200 dark:text-white"
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full px-4 py-2 border rounded-md dark:bg-gray-200 dark:text-white"
            required
          />
          <button
            type="submit"
            className="w-full bg-[#00318e] text-white py-2 rounded hover:bg-blue-500"
          >
            Login
          </button>
          <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
            Don't have an account? <Link to="/register" className="text-blue-600 hover:underline">Register here</Link>
          </p>

          <div>
            <span className='text-center block mb-3 text-white'>OR</span>
            <RegisterSocialsComponent type="login"/>
          </div>

        </form>
      </div>
    </section>
  );
};

export default LoginComponent;
